module.exports = __webpack_public_path__ + "img/forbidden.ffb6dd94.svg";